import Swal from 'sweetalert2';

/**
 * Alerta de éxito
 */
export const showSuccess = (title = 'Éxito', text = '') => {
    return Swal.fire({
        icon: 'success',
        title,
        text,
        confirmButtonText: 'Aceptar',
    });
};

/**
 * Alerta de error
 */
export const showError = (title = 'Error', text = '') => {
    return Swal.fire({
        icon: 'error',
        title,
        text,
        confirmButtonText: 'Aceptar',
    });
};

/**
 * Alerta informativa
 */
export const showInfo = (title = 'Información', text = '') => {
    return Swal.fire({
        icon: 'info',
        title,
        text,
        confirmButtonText: 'Aceptar',
    });
};

/**
 * Confirmación con botones
 */
export const showConfirm = ({
    title = '¿Estás seguro?',
    text = '',
    confirmButtonText = 'Sí',
    cancelButtonText = 'Cancelar',
    icon = 'warning',
}) => {
    return Swal.fire({
        title,
        text,
        icon,
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText,
        cancelButtonText,
    });
};

/**
 * Mostrar indicador de carga
 */
export const showLoading = (title = 'Cargando...') => {
    return Swal.fire({
        title,
        allowOutsideClick: false,
        didOpen: () => {
            Swal.showLoading();
        },
    });
};

/**
 * Cerrar cualquier alerta activa
 */
export const closeSwal = () => {
    Swal.close();
};